import MarkdownToJsx from 'markdown-to-jsx';
import { clsx } from 'clsx';
import styles from './Markdown.module.scss';

export type MarkdownProps = {
  /** The markdown string to render. */
  children: string;

  /** Optional property for overriding styles. */
  className?: string;

  /** Optional property for overriding styles. */
  style?: React.CSSProperties;
};

/**
 * Renders markdown content with consistent design system styling.
 *
 * Prevents XSS attacks by disallowing raw HTML.
 */
export const Markdown = ({ children, className, style }: MarkdownProps) => {
  return (
    <div data-zds className={clsx(styles.root, className)} style={style}>
      <MarkdownToJsx options={{ disableParsingRawHTML: true }}>
        {children}
      </MarkdownToJsx>
    </div>
  );
};
